const jianjian = () => import('@/views/payjinjian/jinjian')
export const payjinjian =[
    {
        path: '/pay/jinjian',
        name: '支付进件',
        component: jianjian,
        meta: {
          title: '申请店播pay'
        }
      },
]


// WEBPACK FOOTER //
// ./src/router/payjinjian.route.js